import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <path d="M0 0V14L11 7L0 0Z" fill="white" />
    </>
  ),
  'Play',
  '0 0 11 14'
);
